/* eslint-disable no-unused-vars */
import { useMemo, memo, useRef, useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import * as S from './CustomInputAutosize.styled';
import { ErrorMarker, Encrypt, DeleteIcon } from 'assets/icons';
import { IconButton } from 'components';

export const CustomInputAutosize = memo(
  forwardRef(
    (
      {
        value,
        name,
        onChange,
        placeholder,
        disabled,
        id,
        error,
        errorText = 'error',
        deleteIcon,
        deleteIconOnClick,
        onBlur,
        containerStyle,
        inputStyle,
        readOnly,
      },
      parentRef,
    ) => {
      const textareaRef = useRef(null);

      useImperativeHandle(parentRef, () => ({
        focus: () => {
          textareaRef.current.focus();
        },
        // ...other methods or properties you want to provide
      }));
      const [isHovered, setIsHovered] = useState(false);
      const [isFocused, setIsFocused] = useState(false);
      const showClearButton = value && (isHovered || isFocused);

      useEffect(() => {
        if (textareaRef.current) {
          textareaRef.current.style.height = 'auto';
          textareaRef.current.style.height = `${textareaRef.current.scrollHeight + 5}px`;
        }
      }, [value]);

      return (
        <S.Container
          height={textareaRef.current?.scrollHeight ?? ''}
          style={containerStyle}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <S.MyTextArea
            readOnly={readOnly}
            name={name}
            value={value}
            onChange={onChange}
            ref={textareaRef}
            placeholder={placeholder}
            id={id}
            disabled={disabled}
            onBlur={() => {
              onBlur && onBlur();
              setIsFocused(false);
            }}
            error={error}
            style={inputStyle}
          />
          {disabled && (
            <S.DisadledIcon>
              <Encrypt />
            </S.DisadledIcon>
          )}
          {error && (
            <S.Error>
              <ErrorMarker />
              <span>{errorText}</span>
            </S.Error>
          )}

          {showClearButton && deleteIcon && value && (
            <S.RightIconWrap>
              <IconButton.SmallSize
                isDefaultMuted
                icon={DeleteIcon}
                type={IconButton.btnTypes.tertiary}
                onClick={() => {
                  textareaRef.current.focus();
                  deleteIconOnClick();
                }}
              />
            </S.RightIconWrap>
          )}
        </S.Container>
      );
    },
  ),
);
CustomInputAutosize.displayName = 'CustomInputAutosize';
